'use client'

import { ReactNode } from 'react'
import BaseLayoutTemplate from './BaseLayoutTemplate'

interface FullLayoutTemplateProps {
  children: ReactNode
  brand?: any
  globalData?: any
  loginEl?: any
  setLoginEl?: any
  headerMenuJson?: any
  footerJson?: any
  pageInserts?: any
  env?: string
}

/**
 * Full Layout Template - For pages that need complete header and footer
 * Used for: Home, product pages, general content pages
 */
export default function FullLayoutTemplate(props: FullLayoutTemplateProps) {
  return (
    <div data-layout-type="full">
      <BaseLayoutTemplate {...props} />
    </div>
  )
}